// extracted by mini-css-extract-plugin
export default {"simple-example":"public_simple-example_fP2nU","simple-example__meeting-selector":"public_simple-example__meeting-selector_OLQ91","loading-div":"public_loading-div_VmwtA"};